import { createApp } from 'vue';
import App from './App.vue';
import { createPinia } from 'pinia';
import VueSimpleSVG from 'vue3-simple-svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.scss';
import { normalizeBasePath } from './utils/slugUtils.js';
import { useCarStore } from './stores/car';

// The block now gives each instance an id like "crc-pls-module-<random>"
// (instead of always the same literal "crc-pls-module"), so multiple copies
// of this block can live on one page. Mount one Vue app per match.
const els = document.querySelectorAll('[id^="crc-pls-module"]');

els.forEach((el) => {
    const app = createApp(App);

    const pinia = createPinia();
    app.use(pinia);
    app.use(VueSimpleSVG);

    const ctx = {
        el: el,
        apiUrl: el.dataset.plsApi,
        apiKey: el.dataset.plsCrcApikey,
        vueUrl: el.dataset.plsVueUrl,
        title:  el.dataset.plsTitle,
        subtitle: el.dataset.plsSubtitle,
        btnText: el.dataset.plsBtnText,
        layoutCols: Number(el.dataset.plsLayout) || 4,
        basePath: normalizeBasePath(el.dataset.plsBasePath),
    };

    app.provide('plsContext', ctx);
    app.config.globalProperties.$plsContext = ctx;



    const store = useCarStore(pinia);
    store.setContext(ctx);

    app.mount(`#${el.id}`)
});
